/**
 * Component: Taste Profile Onboarding Flow with Container + View Pattern
 * 
 * This is a component-level file that delegates to the centralized 
 * Container + View pattern for clean separation of concerns
 */
import TasteProfileOnboardingFlowContainer from './TasteProfileOnboardingFlow.container';
import type { TasteProfileData } from './TasteProfileOnboardingFlow.container';

interface TasteProfileOnboardingFlowProps {
  onComplete: (data: TasteProfileData) => void;
  initialData?: Partial<TasteProfileData>;
}

export function TasteProfileOnboardingFlow(props: TasteProfileOnboardingFlowProps) {
  // Component level just delegates to container - clean and simple
  return <TasteProfileOnboardingFlowContainer {...props} />;
}

// Re-export the type for backward compatibility
export type { TasteProfileData };

